import React from "react";
import NavBar from "component/NavBar";
import Footer from "component/Footer";
import { about, aboutme, services } from "../assets";
import Phone from "component/Phone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faShieldHalved,
  faHandsHelping,
  faAward,
  faUserDoctor,
  faBullseye,
} from "@fortawesome/free-solid-svg-icons";

const values = [
  {
    icon: faHeart,
    title: "Client First",
    description:
      "The client is our top priority in everything we do. Your wellness and satisfaction guide every decision we make.",
  },
  {
    icon: faShieldHalved,
    title: "Integrity",
    description:
      "We uphold the highest standards of integrity, ensuring honesty and ethical conduct in all our endeavors.",
  },
  {
    icon: faHandsHelping,
    title: "Respect",
    description:
      "We value and respect the unique experiences, perspectives, and needs of each client we serve.",
  },
];

const stats = [
  { number: "10+", label: "Years Experience" },
  { number: "1000+", label: "Clients Served" },
  { number: "3", label: "States Served" },
  { number: "24/7", label: "Support Available" },
];

const AboutMe = () => {
  return (
    <div className="bg-white">
      <NavBar />
      <Phone />

      <div className="relative h-[400px] md:h-[500px] lg:h-[600px]">
        <img
          src={about}
          alt="About Blissful Days"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        <div className="absolute inset-0 flex items-center justify-center px-6">
          <div className="text-center animate-fade-in">
            <h1 className="text-display-sm md:text-display-md lg:text-display-lg text-white font-bold mb-4">
              About Blissful Days
            </h1>
            <p className="text-body-lg md:text-heading-sm text-white/90 max-w-2xl mx-auto">
              Compassionate psychiatric care for your mental wellness journey
            </p>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-neutral-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-6">
              Who We Are
            </h2>
            <div className="h-1 w-24 bg-primary-500 mx-auto mb-8"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl shadow-medium p-8 md:p-10 hover:shadow-large transition-shadow duration-300">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faHeart}
                    className="text-primary-600 text-lg"
                  />
                </div>
                <h3 className="text-heading-md text-neutral-900">Our Commitment</h3>
              </div>
              <p className="text-body-lg text-neutral-700 leading-relaxed">
                Blissful Days Psychiatric Services is a telehealth-based practice committed to providing high-quality, accessible mental health services. Our team of experienced professionals believes in creating a safe and non-judgmental space where individuals can freely express their thoughts, feelings, and be truly heard.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-medium p-8 md:p-10 hover:shadow-large transition-shadow duration-300">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faBullseye}
                    className="text-primary-600 text-lg"
                  />
                </div>
                <h3 className="text-heading-md text-neutral-900">Our Approach</h3>
              </div>
              <p className="text-body-lg text-neutral-700 leading-relaxed">
                Through evidence-based practices and a holistic approach, we provide personalized treatment plans tailored to each client's specific needs. We strive to empower our clients by instilling a sense of control over their condition and aim at contributing to a healthier and more fulfilling life. We are devoted to creating a trusting and empathetic environment where individuals feel secure on their path to mental wellness.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="relative rounded-2xl overflow-hidden shadow-medium group">
                <img
                  src={services}
                  alt="Our Mission"
                  className="w-full h-[400px] md:h-[500px] object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent"></div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faBullseye}
                    className="text-primary-600 text-xl"
                  />
                </div>
                <h2 className="text-heading-xl md:text-display-sm text-neutral-900">
                  Our Mission
                </h2>
              </div>
              <p className="text-body-lg text-neutral-700 leading-relaxed mb-8">
                Our mission is to improve our clients' quality of life by providing accessible, safe, and evidence-based mental healthcare. We believe that everyone deserves access to compassionate psychiatric services that honor their dignity and support their journey to wellness.
              </p>

              <h3 className="text-heading-md text-neutral-900 mb-6">Our Core Values</h3>
              <div className="space-y-6">
                {values.map((value, index) => (
                  <div key={index} className="flex items-start gap-4 group">
                    <div className="flex-shrink-0 w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                      <FontAwesomeIcon
                        icon={value.icon}
                        className="text-primary-600 group-hover:text-white transition-colors"
                      />
                    </div>
                    <div>
                      <h4 className="text-heading-sm text-neutral-900 mb-1">
                        {value.title}
                      </h4>
                      <p className="text-body-md text-neutral-600 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 bg-gradient-to-br from-primary-500 to-primary-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-display-md md:text-display-lg text-white font-bold mb-2">
                  {stat.number}
                </div>
                <div className="text-body-lg text-white/90">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faUserDoctor}
                  className="text-primary-600 text-xl"
                />
              </div>
              <h2 className="text-heading-xl md:text-display-sm text-neutral-900">
                Our Provider
              </h2>
            </div>
            <div className="h-1 w-24 bg-primary-500 mx-auto"></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="bg-white rounded-2xl shadow-medium p-8 md:p-10">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={faAward}
                      className="text-primary-600 text-2xl"
                    />
                  </div>
                  <div>
                    <h3 className="text-heading-md text-neutral-900">
                      Nneka Wogu
                    </h3>
                    <p className="text-body-md text-primary-600 font-semibold">
                      MSN, CRNP-PMH
                    </p>
                  </div>
                </div>

                <p className="text-body-lg text-neutral-700 leading-relaxed mb-4">
                  Nneka Wogu is an experienced board-certified psychiatric nurse practitioner with a passion for transforming lives through compassionate mental healthcare.
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-2 h-2 bg-primary-500 rounded-full mt-2"></div>
                    <p className="text-body-md text-neutral-700">
                      Extensive experience in hospitals, outpatient mental health clinics, and addiction centers
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-2 h-2 bg-primary-500 rounded-full mt-2"></div>
                    <p className="text-body-md text-neutral-700">
                      Specializes in treating anxiety, depression, ADHD, bipolar disorder, PTSD, OCD, addiction, and other psychiatric conditions
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-2 h-2 bg-primary-500 rounded-full mt-2"></div>
                    <p className="text-body-md text-neutral-700">
                      Values the therapeutic relationship by actively listening, empathizing, and building trust with every patient
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-medium">
                <img
                  src={aboutme}
                  alt="Nneka Wogu"
                  className="w-full h-[500px] md:h-[600px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-heading-xl md:text-display-sm text-neutral-900 mb-6">
            Ready to Begin Your Journey?
          </h2>
          <p className="text-body-lg text-neutral-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            Take the first step towards better mental health. Our compassionate team is here to support you every step of the way.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/contact">
              <button className="px-8 py-4 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                Schedule Consultation
              </button>
            </a>
            <a href="/mainservicepage">
              <button className="px-8 py-4 bg-white border-2 border-primary-500 text-primary-600 font-semibold rounded-lg hover:bg-primary-50 transition-all duration-300">
                View Our Services
              </button>
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutMe;
